import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/main.scss";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home/Home";
import About from "./pages/about/About";
import Page404 from "./pages/errors/Page404";
import ScrollToTop from "./components/ScrollToTop";
import Posts from "./pages/posts/Posts";
import Post from "./pages/post/Post";
import Service from "./pages/service/Service";
import { Notice } from "./pages/notice/Notice";
import { Welcome } from "./pages/welcome/Welcome";
import { SectionDetail } from "./pages/welcome/pages/section/SectionDetail";
import { Sections } from "./pages/welcome/pages/sections/Sections";
import { Media } from "./pages/media/Media";
import { Page } from "./pages/page/Page";
import { EmailActivation } from "./pages/activation/EmailActivation";
import Articles from "./pages/articles/Articles";
import Article from "./pages/article/Article";
import Contacts from "./pages/contacts/Contacts";
import Evisa from "./pages/evisa/Evisa";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<Home />} />
          <Route path="about/:slug" element={<About />} />
          <Route path="posts" element={<Posts />} />
          <Route path="articles" element={<Articles />} />
          <Route path="media" element={<Media />} />
          <Route path="post/:slug" element={<Post />} />
          <Route path="article/:slug" element={<Article />} />
          <Route path="services/:slug" element={<Service />} />
          <Route path="notices/:slug" element={<Notice />} />
          <Route path="pages/:slug" element={<Page />} />
          <Route path="email-activation/:token" element={<EmailActivation />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="evisa" element={<Evisa />} />
          <Route path="*" element={<Page404 />} />
        </Route>
        <Route path="/welcome/" element={<Welcome />}>
          <Route index element={<Sections />} />
          <Route path="section/:slug" element={<SectionDetail />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </Provider>
);
